import {errorHttpMessage} from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'
import {makeRestoreAction} from '@/utils/catalogRestoreAction'

export const saveLegalIncapacityLimit = async ({commit}, legalLimit) => {
    try{
        const { data:result } = await configurationClient.post('/catalog/incapacityLegalLimit/create', legalLimit)        
        const { message, error } = result.result    
        return {message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const findLegalIncapacityLimitById = async ({commit}, legalLimitId) => {
    try{        
        const { data:result } = await configurationClient.get(`/catalog/incapacityLegalLimit/show/${legalLimitId}`)        
        const { data, message, error } = result.result    
        return {data, message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const editLegalIncapacityLimit = async ({commit}, legalLimit) => {
    try{
        const { data:result } = await configurationClient.post(`/catalog/incapacityLegalLimit/${legalLimit.id}`, legalLimit)        
        const { message, error } = result.result    
        return { message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const deleteLegalIncapacityLimit = async ({commit}, legalLimitId) => {
    try{        
        const { data:result } = await configurationClient.delete(`/catalog/incapacityLegalLimit/destroy/${legalLimitId}`)        
        const { message, error } = result.result    
        return {message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const downloadExcelReport = async ({commit}, fileName) => {
    try{        
        const response = await configurationClient.get(`/catalog/incapacityLegalLimit/download`,{
            responseType: 'blob'
        })                
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
    } catch(ex) {                             
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const restoreById = makeRestoreAction(configurationClient, '/catalog/incapacityLegalLimit')